<template>
  <div :class="`stand stand-${standId}`">
    <img :src="imageUrl" alt="" />
    <p class="text">{{ product.attributes.standText }}</p>
  </div>
</template>
<script>
import { photoCategoryId } from "../../../../config";
import { url } from "../../../../helpers";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      product: "product/getProduct",
    }),
    imageUrl() {
      if(!this.product){
        return ''
      }
      const id = this.standId;

      if(this.product.category_id === photoCategoryId){
        return this.url(`/img/product/stand/${id}_flat.png`);
      }

      return this.url(`/img/product/stand/${id}.png`);
    },
    standId(){
      if(!this.product){
        return ''
      }
      return this.product.attribute_values.stand.id;
    }
  },
  setup() {
    return {
      url,
    };
  },
};
</script>
